import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";

export function Sponsors({sponsors}){

    const reference = useRef(); // Referencia az elemhez
    const location = useLocation(); // Aktuális URL-t figyeljük
    useEffect(() => {
        const nav = document.querySelector('nav');
        const navHeight = nav ? nav.offsetHeight : 0;

        // scroll függvény kis helperként
        const scrollToRef = (ref) => {
            if (ref && ref.current) {
                const sectionTop = ref.current.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: sectionTop - navHeight,
                    behavior: 'smooth'
                });
            }
        };

        // Delay-t is belerakunk, hogy biztos minden renderelődjön
        const scrollTimeout = setTimeout(() => {
            if (location.hash === '#sponsors') {
                scrollToRef(reference);
            }
        }, 500); // 100ms delay segít a komponens renderelés után

        return () => clearTimeout(scrollTimeout); // tisztítás ha kell
    }, [location.hash, reference.current]);

    return (
        <section ref={reference} id={'sponsors'}>
            <div className="container">
                <div className="row justify-content-center mb-6">
                    <div className="col-xl-6 col-md-8 col-sm-10 text-center"
                         data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 1200, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                        <h4 className="mb-0 text-dark-gray fw-700 ls-minus-1px w-85 xl-w-100 mx-auto">Partnerek és
                            Támogatók</h4>
                    </div>
                </div>
                <div className="row row-cols-1 row-cols-md-3 justify-content-center mb-7 sm-mb-45px"
                     data-anime={JSON.stringify({
                         "el": "childs",
                         "translateY": [50, 0],
                         "rotateX": [30, 0],
                         "opacity": [0, 1],
                         "duration": 1200,
                         "delay": 0,
                         "staggervalue": 150,
                         "easing": "easeOutQuad"
                     })}>
                    {Array.isArray(sponsors) && sponsors.map((sponsor, idx) => {
                        return <div key={idx} className="col sm-mb-30px pb-2">
                            <div
                                className="bg-white h-100 border border-color-extra-medium-gray border-radius-6px text-center box-shadow-quadruple-large d-flex align-items-center justify-content-center p-20px p-sm-40px ps-md-60px pe-md-60px">
                                {/* Középre igazított konténer padding nélkül, hogy a magas logó is beférjen */}
                                <a href={sponsor.externalUrl} target={'_blank'} className="w-100 py-10 d-flex justify-content-center">
                                    <img
                                        src={sponsor.imgUrl}
                                        className=""
                                        alt={sponsor.name}
                                        style={{ maxWidth:"100%", objectFit: 'contain', height:'180px'}} // biztos ami
                                        // biztos
                                    />
                                </a>
                            </div>
                        </div>
                    })}
                </div>
                <div className="row justify-content-center align-items-center"
                     data-anime='{ "translateY": [50, 0], "opacity": [0,1], "duration": 1200, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                </div>
            </div>
        </section>
    )
}